/** @jsxImportSource @emotion/react */

import { message } from "antd";
import { ReactComponent as IconNext } from "assets/common/icons/chevron-right.svg";
import * as ImageMemberVip from "assets/common/images/member-vip";
import { PATH } from "constants/path";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import _isEqual from "lodash/isEqual";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { selectUsername } from "store/auth";
import { initialState, selectDataMemberVip } from "store/memberVip";
import { getMemberVip } from "store/memberVip/member.thunk";

import CurrentLevel from "./CurrentLevel";
import { MemberVipPageStyle } from "./style.index";
import TableLvUp from "./TableLevelUp";

type TypeBtnMemberVip = {
  image: string;
  name: string;
  path: string;
};

export const ListBtnMemberVip: TypeBtnMemberVip[] = [
  {
    image: ImageMemberVip.ImageVipDetail,
    name: "Chi tiết VIP",
    path: PATH.User.MemberVipDetail,
  },
  {
    image: ImageMemberVip.ImageVipReward,
    name: "Yêu cầu nhận thưởng",
    path: PATH.User.AwardVip,
  },
  {
    image: ImageMemberVip.ImageVipHistory,
    name: "Lịch sử nâng cấp",
    path: PATH.User.HistoryUpdateVip,
  },
];

const MemberVipPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const username = useSelector(selectUsername);

  const { data: dataMemberVip } = useAppSelector(selectDataMemberVip);

  const handleNavigate = (path: string) => {
    if (path === "") {
      message.warning({
        key: "member-vip",
        content: "Tính năng hiện tại đang bảo trì!!",
      });
      return;
    }
    navigate(path);
  };

  const isDataEmptyMemberVip = _isEqual(
    initialState.dataMemberVip.data,
    dataMemberVip,
  );

  useEffect(() => {
    if (!username) return;
    if (!isDataEmptyMemberVip) return;
    dispatch(getMemberVip({ username }));
  }, [username]);

  return (
    <div css={MemberVipPageStyle.wrapper}>
      <CurrentLevel current_level={dataMemberVip.current_level} />

      <TableLvUp {...dataMemberVip.next_level} />

      <div css={MemberVipPageStyle.btnGroup}>
        {ListBtnMemberVip.map((item, index) => (
          <Link
            to={item.path}
            css={MemberVipPageStyle.btnMemberVip}
            key={index}
            onClick={() => handleNavigate(item.path)}
          >
            <img src={item.image} alt="" />
            <span>{item.name}</span>
            <IconNext />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MemberVipPage;
